import React, { useEffect, useState, useRef, useCallback } from 'react';
import RideHistoryItem from "./RideHistoryItem";
import PageLabel from "./PageLabel";
import backendApi from "../services/backendApi";

function RideHistory() {
    const [rides, setRides] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [selectedRide, setSelectedRide] = useState(null);
    const [cursor, setCursor] = useState(null);
    const [triggerLoad, setTriggerLoad] = useState(false);

    const observer = useRef();

    const lastRideRef = useCallback(node => {
        if (loading || !hasMore) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                setTriggerLoad(true);
            }
        }, {
            root: document.querySelector('.rideHistory__list'),
            rootMargin: '10px',
        });

        if (node) observer.current.observe(node);
    }, [loading, hasMore]);

    useEffect(() => {
        const fetchInitial = async () => {
            setLoading(true);

            try {
                const response = await backendApi.get('/api/rides', {
                    params: { limit: 15 }
                });

                const data = response.data;

                setRides(data.rides);
                setHasMore(data.rides.length > 0);
                setCursor(data.next_cursor || null);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchInitial();
    }, []);

    useEffect(() => {
        if (!triggerLoad) return;
        if (loading || !hasMore) {
            setTriggerLoad(false);
            return;
        }
        if (!cursor) {
            setHasMore(false);
            setTriggerLoad(false);
            return;
        }

        const fetchMore = async () => {
            setLoading(true);

            try {
                const response = await backendApi.get('/api/rides', {
                    params: { limit: 15, cursor: cursor }
                });

                const data = response.data;

                setRides(prev => [...prev, ...data.rides]);
                setHasMore(data.rides.length > 0);
                setCursor(data.next_cursor || null);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
                setTriggerLoad(false);
            }
        };

        fetchMore();
    }, [triggerLoad, cursor, loading, hasMore]);

    const handleRideClick = (ride) => {
        setSelectedRide(ride);
    };

    return (
        <div className="rideHistory pageContent">
            <PageLabel text={"Kelionės"} />

            <div className="rideHistory__list">
                {rides.map((ride, index) => (
                    <RideHistoryItem
                        key={ride.id}
                        ride={ride}
                        onClick={handleRideClick}
                        refCallback={index === rides.length - 1 ? lastRideRef : null}
                    />
                ))}
            </div>
        </div>
    );
}

export default RideHistory;
